/*
All the marketing param values come inside the `sc_cmp` query param.
It is automatically tracked by ttt and removed automatically from the url

We have the following marketing cases:
- SEA: Search Engine Advertising (eg ads in Google)
  - SEA_CAMPAIGNS: display a search alert modal in the Search Page
*/

export const SEA_CAMPAIGNS = [
  // Following param added in https://jira.xing.hh/browse/JSR-1573
  '54756a81-531d-411b-baf7-9ab4a6fb159b.:ebb5a6a9-dfea-44e7-90aa-1906f85d0b06',
];
